export enum MessageType {
  AI = 'ai',
  Human = 'human',
}
